import { Button as HeadlessUiButton } from "@headlessui/react"
import { twMerge } from "tailwind-merge"

interface Props {
  className?: string
  disabled?: boolean
  onClick?: () => void
  title: string
  type?: "button" | "submit" | "reset"
}

export default function Button({
  className,
  disabled = false,
  onClick,
  title,
  type = "button",
}: Props) {
  return (
    <HeadlessUiButton
      className={twMerge("custom-button-primary", className)}
      disabled={disabled}
      onClick={onClick}
      type={type}
    >
      {title}
    </HeadlessUiButton>
  )
}
